import { createApi } from "@reduxjs/toolkit/query/react";
import { components } from "../../types/api";
import { baseQueryWithReauth } from "../../utils/baseQuery";

type PaginatedAsyncOperationsApiResponse =
  components["schemas"]["ApiResponse_PaginatedAsyncOperationsResponse_"];
type AsyncOperationApiResponse =
  components["schemas"]["ApiResponse_AsyncOperationResponse_"];
type OperationStatus = components["schemas"]["OperationStatus"];
type OperationType = components["schemas"]["OperationType"];

type OperationsQueryParams = {
  page?: number;
  pageSize?: number;
  startDate?: string;
  endDate?: string;
  status?: OperationStatus;
  type?: OperationType;
};

type ErrorOperationsQueryParams = Omit<
  OperationsQueryParams,
  "status" | "type"
>;

export const asyncOperationsApi = createApi({
  reducerPath: "asyncOperationsApi",
  baseQuery: baseQueryWithReauth,
  tagTypes: ["AsyncOperations"],
  endpoints: (builder) => ({
    getOperations: builder.query<
      PaginatedAsyncOperationsApiResponse,
      OperationsQueryParams | undefined
    >({
      query: (params) => ({
        url: "/async-operations",
        params,
      }),
      providesTags: ["AsyncOperations"],
    }),
    getErrorOperations: builder.query<
      PaginatedAsyncOperationsApiResponse,
      ErrorOperationsQueryParams | undefined
    >({
      query: (params) => ({
        url: "/async-operations/errors",
        params,
      }),
      providesTags: ["AsyncOperations"],
    }),
    getOperationById: builder.query<AsyncOperationApiResponse, string>({
      query: (id) => `/async-operations/${id}`,
      providesTags: (_result, _error, id) => [{ type: "AsyncOperations", id }],
    }),
  }),
});

export const {
  useGetOperationsQuery,
  useGetErrorOperationsQuery,
  useGetOperationByIdQuery,
} = asyncOperationsApi;
